












import Vue from 'vue';

export default Vue.extend({
  name: 'BookmarkLink',
  props: {
    id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    newSor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active(): boolean {
      return this.id !== null;
    },
    iconClass(): string {
      return `fa fa-star${this.active ? '' : '-o'}`;
    },
  },
  methods: {
    async openBookmarkModal() {
      if (this.newSor) {
        let res;

        try {
          const modalConfig = {
            type: 'BookmarkCard',
            data: {
              csrfToken: this.csrfToken,
              id: this.id,
              title: this.title,
              preventRedirect: true,
            },
          };

          res = await this.$store.dispatch('modals/show', modalConfig);
        } catch (err) {
          // User canceled modal
        }

        if (res) this.$emit('change', res);
      } else {
        window.GGRC.zenModal.show({
          type: 'BookmarkCard',
          data: {
            csrfToken: this.csrfToken,
            id: this.id,
            title: this.title,
          },
          config: {
            ignoreUrl: true,
          },
        });
      }
    },
  },
});
